/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneContactEditorial as ResolvedStandaloneContactEditorial } from 'base/components/standalone/ContactEditorial';

export const ContactEditorial: typeof ResolvedStandaloneContactEditorial = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneContactEditorial {...props} />
    );
});

export type ContactEditorialProps = PropsFromComponent<typeof ContactEditorial>;

/** @deprecated Use slot architecture instead */
export const ContactEditorialWith = (extras: DynamicStandaloneExtras): typeof ContactEditorial => {
    return function ContactEditorial(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ContactEditorial');
        return <ResolvedStandaloneContactEditorial {...mergeProps({ options: { theme } }, props)} />;
    }
}